// extracted by mini-css-extract-plugin
export default {"galeryContainer":"ActionImageType_galeryContainer__ANutO","block":"ActionImageType_block__NIvXB","selected":"ActionImageType_selected__jq11f"};